import { STORAGE_KEYS } from '@/constants/CheckoutConstants'
import { useSessionStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

export const useDoiOptInStore = defineStore('doiOptIn', {
  state: () => ({
    hasOptedInThisPurchase: useSessionStorage(
      STORAGE_KEYS.DOI_OPTED_IN_THIS_PURCHASE,
      false
    ),
    // Whether the cart-page checkbox is currently ticked. Submission is deferred
    // until the "go to checkout" button is clicked (VIP-12044), so this just holds
    // the UI state in between — no need to persist it across reloads.
    cartCheckboxChecked: false
  }),
  actions: {
    markOptedIn() {
      this.hasOptedInThisPurchase = true
    }
  }
})
